let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3KJm3")).then(() => parcelRequire('6ceyn'));